import useAuth from 'auth/useAuth';
import React from 'react';

export const CurrentUserDisplayName = () => {
  const { profile } = useAuth();

  return <>{profile.displayName}</>;
};
